// removed by extract-text-webpack-plugin
module.exports = {"Auth":"Auth__Auth__2YUr1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Auth.css
// module id = 166
// module chunks = 0